import angular = require("angular");
import TPL = require("templates");

export class AttendantsDirective {

  template = TPL.contentDirectives.attendants;
  scope = {
    params: "=params"
  };
  link;

  constructor($filter) {
    var translate = $filter('translate');

    this.link = (scope, el, attrs) => {

      var size = scope.params.size || "xs";

        scope.vm = {
          avatar0: {dark: true, image: {size: size}, label: {position: "left"}},
          avatar1: {dark: true, image: {size: size}},
          avatar2: {dark: true, image: {size: size}},
          avatar3: {dark: true, image: {size: size}, label: {position: "right"}},
          avatarList: [],
          getAvatars: () => {
            while(scope.vm.avatarList.length > 0) {
              scope.vm.avatarList.pop();
            }

            if (scope.params.items) {
              var attendants = scope.params.items;

              var maxAvatarCount = Math.min(attendants.length, 4);

              for (var i = 0; i < maxAvatarCount; i++) {
                scope.vm.avatarList.push(scope.vm["avatar" + i]);
                if (attendants[(attendants.length - i) - 1].profile.avatar) {
                  scope.vm.avatarList[i].image.src = attendants[(attendants.length - i) - 1].profile.avatar.m;
                }

                if (attendants[(attendants.length - i) - 1].profile.first_name) {
                  scope.vm.avatarList[i].initials = {
                    first_name: attendants[(attendants.length - i) - 1].profile.first_name,
                    last_name: attendants[(attendants.length - i) - 1].profile.last_name,
                  }
                }
              }

              if (scope.params.title) {
                scope.vm.avatar0.label.text = translate(scope.params.title);
              } else {
                scope.vm.avatar0.label.text = undefined; //buu
              }

              if (attendants.length > maxAvatarCount) {
                var diff = attendants.length - maxAvatarCount;
                scope.vm.avatar3.label.text = "+" + diff + " more";
              } else {
                scope.vm.avatar3.label.text = undefined; //buu
              }
            }

            return scope.vm.avatarList;
          }
        };
    }
  }

  static factory() {
    var tmp = (a) => new AttendantsDirective(a);
    tmp.$inject = ["$filter"];
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/attendants.ts
 **/